import { render, staticRenderFns } from "./ChatBotDataSrcAdd.vue?vue&type=template&id=b7aa3498&scoped=true"
import script from "./ChatBotDataSrcAdd.vue?vue&type=script&lang=js"
export * from "./ChatBotDataSrcAdd.vue?vue&type=script&lang=js"
import style0 from "./ChatBotDataSrcAdd.vue?vue&type=style&index=0&id=b7aa3498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aa3498",
  null
  
)

export default component.exports